import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import PageSeo from "@/components/PageSeo";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let mounted = true;
    api.get("/gallery")
      .then((r) => { if (mounted) setItems(r.data); })
      .catch((e) => { if (mounted) setErr(e.message); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  return (
    <div data-testid="gallery-page" className="pt-32 pb-24">
      <PageSeo
        title="Gallery — Interiors, Veranda & Wellington Lake Views"
        description="Look inside The Barracks Bistro — teak-table veranda, arched interior, lawn events and the Nilgiri lake beyond."
        path="/gallery"
      />
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="eyebrow">Gallery</div>
        <h1 className="mt-3 text-5xl sm:text-6xl max-w-3xl leading-[1]">
          Rooms, evenings, <span className="italic text-[hsl(var(--brass))]">and a lake.</span>
        </h1>

        {loading && (
          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="gallery-loading">
            {["a", "b", "c", "d", "e", "f"].map((k) => (
              <div key={`skel-${k}`} className="aspect-[4/5] bg-[hsl(var(--bg-2))] animate-pulse" />
            ))}
          </div>
        )}

        {err && (
          <div className="mt-14 text-[hsl(var(--ink-soft))]" data-testid="gallery-error">
            Couldn't load the gallery right now. Please refresh.
          </div>
        )}

        {!loading && !err && (
          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="gallery-grid">
            {items.map((it, idx) => (
              <figure
                key={it.id}
                data-testid={`gallery-tile-${idx}`}
                className={`relative overflow-hidden group ${idx % 5 === 0 ? "lg:col-span-2 aspect-[16/10]" : "aspect-[4/5]"}`}
              >
                <img
                  src={it.src}
                  alt={it.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                />
                <figcaption className="absolute inset-0 flex flex-col justify-end p-6 text-[hsl(var(--bg))] tile-caption opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="eyebrow !text-[hsl(var(--brass))]">{it.title}</div>
                  <div className="text-sm max-w-md mt-1">{it.caption}</div>
                </figcaption>
              </figure>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
